<template>
	<div class="survey">
		<div class="survey-container mt-10">
			<h2>Tack för att du är kund till Nudgd!</h2>
			<p><em>Vi vill gärna bli ännu bättre och uppskattar din feedback.</em></p>

			<h4 class="mb-3 mt-10" :class="{surveyError: errors.includes('clientSatisfaction')}">Till vilken grad uppfyllde våra produkter/tjänster era förväntningar?</h4>
			<vue-slider marks class="pb-10" :max="10" v-model="clientSatisfaction"></vue-slider>

			<h4 class="mb-3 mt-10" :class="{surveyError: errors.includes('clientNudgingInterest')}">Vilka områden inom beteeendeförändring och nudging är ni intresserade av?</h4>
			<v-checkbox hide-details v-model="clientNudgingInterest" value="Smart mobilitet" label="Smart mobilitet"></v-checkbox>
			<v-checkbox	hide-details v-model="clientNudgingInterest" value="Smart energianvändning" label="Smart energianvändning"></v-checkbox>
			<v-checkbox hide-details v-model="clientNudgingInterest" value="Smart vattenanvändning" label="Smart vattenanvändning"></v-checkbox>
			<v-checkbox	hide-details v-model="clientNudgingInterest" value="Smart avfallshantering och återvinning" label="Smart avfallshantering och återvinning"></v-checkbox>
			<v-checkbox	hide-details v-model="clientNudgingInterest" value="Smart matkonsumtion och mathantering" label="Smart matkonsumtion och mathantering"></v-checkbox>
			<v-checkbox hide-details v-model="clientNudgingInterest" value="Smart hälsofrämjande" label="Smart hälsofrämjande"></v-checkbox>
			<v-checkbox	hide-details v-model="clientNudgingInterest" value="Höja kunskapen om nudging och beteendedesign i vår organisation" label="Höja kunskapen om nudging och beteendedesign i vår organistation"></v-checkbox>
			<v-checkbox	hide-details v-model="clientNudgingInterest" value="Other" label="Annat"></v-checkbox>
			<v-text-field v-if="clientNudgingInterest.includes('Other')" v-model="clientNudgingInterestOther" label="Vänligen ange annat intresseområde"></v-text-field>

			<h4 class="mb-3 mt-10">Kommentarer <span style="font-weight:normal;">(Är det t.ex. något vi kan göra bättre? Eller var det något ni tyckte särskilt mycket om? Ej obligatorisk)</span></h4>
			<v-textarea rows="4" hide-details solo v-model="clientCommentary"></v-textarea>
			<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

			<h4 class="mb-3 mt-6" :class="{surveyError: errors.includes('clientRecommend')}">Hur troligt är det att ni skulle rekommendera Nudgd (eller våra tjänster) till en vän eller kollega? <span style="font-weight:normal;">(på en skala från 0-10)</span></h4>
			<vue-slider marks class="pb-10" :max="10" v-model="clientRecommend"></vue-slider>

			<div class="nudgd-btn inline survey-submit mt-10" @click="submitResponse()">
				Skicka svar
			</div>

			<div style="clear:both;"></div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
	name: 'Vue',
	components: {VueSlider},

	data() {
		return {
	        clientSatisfaction: null,
	        clientRecommend: null,
	        clientNudgingInterest: [],
	        clientNudgingInterestOther: null,
	        clientCommentary: null,

	        // Each array represents the required fields of a step
	        required: [
	        	['clientSatisfaction', 'clientRecommend', 'clientNudgingInterest']
	        ],

	        engaged: [],
	        errors: []
		}
	},

	watch: {
		clientSatisfaction(val) { this.engaged.push('clientSatisfaction') },
		clientRecommend(val) { this.engaged.push('clientRecommend') },
		clientNudgingInterest(val) { this.engaged.push('clientNudgingInterest') },
	},

	methods: {
		validate() {
			let required = this.required[0]
			this.errors = required.filter(val => ! this.engaged.includes(val))

			return this.errors.length === 0
		},

		submitResponse() {
			if ( ! this.validate()) {
				alert('Var god och fyll i alla rödmarkerade fält')
				return
			}

			axios.post(this.$apiUrl + '/api/client-survey/2', {
				slug: this.$route.params.slug,
				clientRecommend: this.clientRecommend,
				clientSatisfaction: this.clientSatisfaction,
				clientCommentary: this.clientCommentary,
				clientNudgingInterest: this.clientNudgingInterest,
				clientNudgingInterestOther: this.clientNudgingInterestOther,
			}).then(res => {
				this.$router.push({name: 'SurveyThanks'})
            })
		}
	}
}
</script>
